<template>
  <div>
    <v-card>
      <v-card-text>
        <v-layout wrap align-center
          ><v-flex xs12 sm3> <h1>Minimum Price Food</h1> </v-flex>
          <v-flex xs12 sm3 class="hidden-xs-only"
            ><v-btn
              round
              color="primary"
              class="black--text elevation-3"
              @click="toAdd()"
              ><v-icon class="pr-1" color="black">add</v-icon> New
              minimum</v-btn
            ></v-flex
          >
          <v-spacer></v-spacer>
          <v-flex xs12 sm3
            ><v-text-field
              v-model="textSearch"
              prepend-inner-icon="search"
              label="Search Minimum Price Food (THB)"
            ></v-text-field></v-flex
        ></v-layout>
        <div
          class="pa-3 mt-4"
          style="border: 1px solid #707070; border-radius: 11px;"
        >
          <v-data-table
            :headers="headers"
            :items="searchedSmallOrderList"
            class="elevation-0"
          >
            <template v-slot:items="props">
              <td>
                {{ searchedSmallOrderList.indexOf(props.item) + 1 }}
              </td>
              <td
                class="text-xs-center"
                style="white-space:nowrap;font-weight: 600;"
                v-if="props.item.sod_district_id == 'All District'"
              >
                {{ props.item.sod_district_id }}
              </td>
              <td
                class="text-xs-center"
                style="white-space:nowrap;font-weight: 600;"
                v-else
              >
                <div v-if="props.item.sod_district_id.length >= 2">
                  <span v-for="n in 2" :key="n">
                    <span v-if="n - 1 > 0">,</span>
                    {{ props.item.sod_district_id[n - 1].district_name_th }}
                  </span>
                  <span
                    v-if="props.item.sod_district_id.length > 2"
                    style="font-weight: bold;color:#919191"
                    >(+{{ props.item.sod_district_id.length - 2 }})</span
                  >
                </div>
                <div v-else>
                  <span
                    v-for="(district, index) in props.item.sod_district_id"
                    :key="index"
                  >
                    <span v-if="index > 0">,</span>
                    {{ district.district_name_th }}
                  </span>
                </div>
              </td>
              <td
                class="text-xs-center"
                style="white-space:nowrap;font-weight: 600;"
                v-if="props.item.sod_store_id == 'All Store'"
              >
                {{ props.item.sod_store_id }}
              </td>
              <td
                class="text-xs-center"
                style="white-space:nowrap;font-weight: 600;"
                v-else
              >
                <div v-if="props.item.sod_store_id.length >= 2">
                  <span v-for="n in 2" :key="n">
                    <span v-if="n - 1 > 0">,</span>
                    {{ props.item.sod_store_id[n - 1].store_name_th }}
                  </span>
                  <span
                    v-if="props.item.sod_store_id.length > 2"
                    style="font-weight: bold;color:#919191"
                    >(+{{ props.item.sod_store_id.length - 2 }})</span
                  >
                </div>
                <div v-else>
                  <span
                    v-for="(district, index) in props.item.sod_store_id"
                    :key="index"
                  >
                    <span v-if="index > 0">,</span>
                    {{ district.store_name_th }}
                  </span>
                </div>
              </td>
              <td class="text-xs-center">
                ฿{{ props.item.sod_minimum_price }}
              </td>
              <td
                style="display:flex;align-items:center;justify-content:center"
              >
                <v-switch
                  v-model="props.item.sod_status"
                  hide-details
                  color="primary"
                  :true-value="2"
                  :false-value="1"
                  style="max-width: 50px"
                  @change="changeStatus(props.item)"
                ></v-switch>
              </td>

              <td class="text-xs-center">
                <v-btn icon @click="toEdit(props.item, props.index)"
                  ><v-icon>edit</v-icon></v-btn
                >
                <v-btn
                  icon
                  :to="
                    `/weserve_admin_login/control/${
                      $route.params.province
                    }/food/minimum-price-food/${smallOrderDifferenceList.indexOf(
                      props.item
                    ) + 1}/${props.item.sod_id}`
                  "
                >
                  <v-icon>remove_red_eye</v-icon></v-btn
                >
              </td>
            </template>
          </v-data-table>
        </div>
        <v-btn class="hidden-sm-and-up" fab fixed bottom right color="primary"
          ><v-icon color="black">add</v-icon></v-btn
        >
      </v-card-text>
    </v-card>
    <formDialog
      :dialog="visibleForm"
      @onClosed="visibleForm = false"
      @onSaved="submitForm($event)"
      :editedIndex="selectedIndex"
      :selectedItem="selectedItem"
    />
  </div>
</template>

<script>
import formDialog from "@/components/back-office/SmallOrderDifference/FormDialog.vue";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      headers: [
        {
          text: "No.",
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          align: "center",
          text: "Selected",
          sortable: false,
          value: "calories",
        },
        { align: "center", text: "Store name", sortable: false, value: "fat" },
        {
          align: "center",
          text: "Minimum food",
          sortable: false,
          value: "carbs",
        },
        { align: "center", text: "Status", sortable: false, value: "protein" },
      ],
      items: [
        {
          sod_id: 1,
          sod_district_id: [],
          sod_store_id: [],
          sod_status: 1,
          sod_minimum_price: "฿80",
          sod_create_at: "",
        },
        {
          sod_id: 2,
          sod_district_id: "",
          sod_store_id: "",
          sod_status: 1,
          sod_minimum_price: "",
          sod_create_at: "",
        },
        {
          sod_id: 3,
          sod_district_id: "",
          sod_store_id: "",
          sod_status: 1,
          sod_minimum_price: "",
          sod_create_at: "",
        },
        {
          sod_id: 4,
          sod_district_id: "",
          sod_store_id: "",
          sod_status: 1,
          sod_minimum_price: "",
          sod_create_at: "",
        },
        {
          sod_id: 5,
          sod_district_id: "",
          sod_store_id: "",
          sod_status: 1,
          sod_minimum_price: "",
          sod_create_at: "",
        },
      ],
      selectedIndex: -1,
      selectedItem: {},
      visibleForm: false,
      isLoading: false,
      textSearch: "",
    };
  },
  async created() {
    await this.getSmallOrderDifferenceList(this.$route.params.province);
  },
  components: {
    formDialog,
  },
  computed: {
    ...mapState({
      smallOrderDifferenceList: (state) =>
        state.fetchOrderListBack.smallOrderDifferenceList,
    }),
    searchedSmallOrderList() {
      if (this.textSearch == "") return this.smallOrderDifferenceList;
      return this.smallOrderDifferenceList.filter(
        (val) => val.sod_minimum_price == this.textSearch
      );
    },
  },
  methods: {
    ...mapActions({
      getSmallOrderDifferenceList:
        "fetchOrderListBack/fetchSmallOrderDifferenceList",
      createSmallOrderDifference:
        "fetchOrderListBack/createSmallOrderDifference",
      updateSmallOrderDifference:
        "fetchOrderListBack/updateSmallOrderDifference",
    }),
    toAdd() {
      this.visibleForm = true;
      this.selectedIndex = -1;
      this.selectedItem = {};
    },
    toEdit(item, index) {
      this.selectedItem = JSON.parse(JSON.stringify(item));
      this.selectedIndex = index;
      this.visibleForm = true;
    },
    async submitForm(event) {
      let response;
      if (this.selectedIndex == -1) {
        response = await this.createSmallOrderDifference({
          payload: event.form,
          province: this.$route.params.province,
        });
      } else {
        if (event.form.sod_is_all_store == true) {
          event.form.sod_store_id = [];
        }
        if (event.form.sod_is_all_district == true) {
          event.form.sod_district_id = [];
        }
        response = await this.updateSmallOrderDifference({
          payload: event.form,
          province: this.$route.params.province,
        });
      }
      event.done();
      if (response == false) return alert(response);
      this.visibleForm = false;
    },
    async changeStatus(item) {
      let payload = JSON.parse(JSON.stringify(item));
      if (item.sod_district_id == "All District") {
        payload.sod_district_id = [];
      } else {
        payload.sod_district_id = item.sod_district_id.map(
          (val) => val.district_id
        );
      }
      if (item.sod_store_id == "All Store") {
        payload.sod_store_id = [];
      } else {
        payload.sod_store_id = item.sod_store_id.map((val) => val.store_id);
      }
      let response = await this.updateSmallOrderDifference({
        payload,
        province: this.$route.params.province,
      });
      if (response == false) {
        if (item.sod_status == 1) {
          item.sod_status = 2;
        } else {
          item.sod_status = 1;
        }
        return;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
